import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--right",
  "use": "icon-slider--right-usage",
  "viewBox": "0 0 10 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 17\" id=\"icon-slider--right\"><path d=\"m1.058 15.763 7-7.031-7-7.032\" stroke=\"currentColor\" stroke-width=\"2.5\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol